import React, { useEffect, useState, useContext } from "react"
import { Container, Row, Col, Collapse } from "reactstrap"
import classnames from "classnames"
import { useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { Skeleton } from "primereact/skeleton"

import { NormalizeJson } from "../../components/Utils/normalizeJson"
import { AuthProtectedContext } from "../../Routes/AuthProtectedContext"

import GridHeader from "../BI_AUT001/Grid/GridHeader"
import GridAccordion from "./Grid/GridAccordion"
import { BI_WS0000Context } from "./context"

import BizinBackend from '../../helpers/bizin_helper'
import {
  fnGetValueByKey,
  fnGroupRecursiveData
} from "../../helpers/functions"
import useGetCsrfToken from "../../Hooks/useGetCsrfToken"

const BI_WS0000 = ({URLParams}) => {
  const { userProfile } = useSelector((state) => ({
    userProfile: state.login.user
  }))

  const { transactionData } = useContext(AuthProtectedContext)
  const data = transactionData || null

  const [gridComponents, setgridComponents] = useState({
    HEAD: [],
    HEADER: [],
    BODY: [],
    FOOTER: [],
  })

  const [dashboardData, setDashboardData] = useState({ grupos: [] })
  const [totalizersList, setTotalizersList] = useState([])
  const [defaultDate, setDefaultDate] = useState([])
  const [isDataLoading, setIsDataLoading] = useState(false)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isLoading, setisLoading] = useState(false)
  const [triggerOnFilter, setTriggerOnFilter] = useState(false)
  const [openAccordions, setOpenAccordions] = useState([])
  const [paramsOnFilter, setParamsOnFilter] = useState([])
  const [inputGlobalSearchValue, setInputGlobalSearchValue] = useState("")
  const csrfToken = useGetCsrfToken()
  const [searchParams] = useSearchParams()
  const chaveFromURL = URLParams || searchParams.get("Chave_Dashboard")
  const [layout, setLayout] = useState(chaveFromURL || "LOGIPLUS_INI")

  const fnReplaceParamKeyWithFilteredValue = (raw) => {
    const mapping = {
      ID_Empresa_Revenda: "Lista_Empresas",
      ID_Empresa_Parceiro: "Lista_Empresas_Parceiras",
    }

    return Object.entries(raw).reduce((acc, [key, entry]) => {
      const target = mapping[key] || key
      let v
      if (Array.isArray(entry)) {
        // Verificar se é o formato novo com values
        if (entry[0] && entry[0].values) {
          v = entry[0].values.map(o => o.value).join(",")
        } else {
          v = entry.map(o => o.value).join(",")
        }
      } else if (entry && typeof entry === "object" && "value" in entry) {
        v = entry.value
      } else {
        v = entry
      }
      acc[target] = v == null ? "" : v
      return acc
    }, {})
  }

  const getData = async () => {
    setIsDataLoading(true)

    const filtrosFormatted = fnReplaceParamKeyWithFilteredValue(paramsOnFilter[0] || {})

    console.log('filtrosFormatted ', filtrosFormatted);
    
    const filtros = {
      1: Number(userProfile.resultset_2[0].ID_Usuario),
      2: "pt-BR",
      3: (typeof layout === "string" && layout.includes("Chave_Dashboard=")) ? layout.split("Chave_Dashboard=").pop() : layout,
      4: filtrosFormatted.ID_Empresa_Origem || null,
      5: filtrosFormatted.ID_Planta_Origem || null,
      6: filtrosFormatted.ID_Empresa_Destino || null,
      7: filtrosFormatted.Data_Inicial || null,
      8: filtrosFormatted.Data_Final || null      
    }

    try {
      const response = await BizinBackend.executeProcedure(
        filtros,
        'FRONT_Workspace_Obter_Componentes_Dashboard',
        csrfToken,
        userProfile?.access_token
      )

      if (!response) return

      const grupos = response?.resultset_1 || []
      const componentesRaw = response?.resultset_2 || []
      setDefaultDate(response?.resultset_3 || [])

      const componentes = componentesRaw.map((comp) => {
        let dados = null, opcoes = null, meta = null

        try {
          if (comp.Conteudo_Dados?.trim()) dados = NormalizeJson(comp.Conteudo_Dados)
          if (comp.Conteudo_Opcoes?.trim()) opcoes = NormalizeJson(comp.Conteudo_Opcoes)
          if (comp.Valor_Meta?.trim()) meta = NormalizeJson(comp.Valor_Meta)
        } catch (err) {
          console.error("Erro ao parsear componente", comp.Descricao_Dashboard_Componente, err)
        }

        return {
          ...comp,
          dadosComponente: dados,
          opcoesComponente: opcoes,
          Valor_Meta: meta
        }
      })

      const gruposComComponentes = grupos.map((grupo) => {
        let opcoesLayout = {}

        if (grupo.Template_Conteudo_Opcoes?.trim()) {
          try {
            opcoesLayout = NormalizeJson(grupo.Template_Conteudo_Opcoes)
          } catch (err) {
            console.error("Erro ao parsear grupo", grupo.ID_Dashboard_Grupo, err)
          }
        }

        return {
          ...grupo,
          Quantidade_Colunas_Grupo: opcoesLayout.Quantidade_Colunas_Grupo || grupo.Quantidade_Colunas_Grupo,
          Quantidade_Linhas_Grupo: opcoesLayout.Quantidade_Linhas_Grupo || grupo.Quantidade_Linhas_Grupo,
          Altura_Linhas: opcoesLayout.Altura_Linhas || grupo.Altura_Linhas,
          GridAutoRows: opcoesLayout.GridAutoRows || grupo.GridAutoRows,
          componentes: componentes.filter(
            (comp) => comp.ID_Dashboard_Grupo === grupo.ID_Dashboard_Grupo
          ),
        }
      })

      const hasValidData = (comp) => {
        const d = comp.dadosComponente
        if (!d) return false
        if (typeof d === 'object' && !Array.isArray(d) && Object.keys(d).length === 0) return false
        if (Array.isArray(d) && d.length === 0) return false
        if (JSON.stringify(d).includes('<#')) return false
        return true
      }

      const gruposVisiveis = gruposComComponentes.filter(
        (grupo) => grupo.componentes.some(hasValidData)
      )

      setDashboardData({ grupos: gruposVisiveis })
      setOpenAccordions(gruposVisiveis.map((g) => g.ID_Dashboard_Grupo))
    } catch (error) {
      console.error("Erro ao carregar dashboard", error)
    } finally {
      setIsDataLoading(false)
    }
  }

  useEffect(() => {
    if (data) {
      const recursiveTree = fnGroupRecursiveData(data)
      setgridComponents({
        HEAD: [recursiveTree[0]?.HEAD],
        HEADER: [recursiveTree[1]?.HEADER],
        BODY: [recursiveTree[2]?.BODY],
        FOOTER: [],
      })
      setTotalizersList(transactionData?.resultset_3)
    }
  }, [data])

  useEffect(() => {
    if (triggerOnFilter) {
      getData().finally(() => setTriggerOnFilter(false))
    }
  }, [triggerOnFilter])

  useEffect(() => {
    getData()
  }, [layout])

  const toggleAccordion = (groupId) => {
    setOpenAccordions((prev) =>
      prev.includes(groupId)
        ? prev.filter((id) => id !== groupId)
        : [...prev, groupId]
    )
  }

  return (
      <BI_WS0000Context.Provider
        value={{
          isLoading,
          userProfile,
          gridComponents,
          setisLoading,
          isOpenModal,
          setIsOpenModal,
          paramsOnFilter,
          setParamsOnFilter,
          fnGetValueByKey,
          triggerOnFilter,
          setTriggerOnFilter,
          fnReplaceParamKeyWithFilteredValue,
          inputGlobalSearchValue,
          setInputGlobalSearchValue,
          defaultDate,
          isDataLoading,
          setIsDataLoading,
          filtersToShow: paramsOnFilter,
          setFiltersToShow: setParamsOnFilter,
          
        }}
      >
      <div className="page-content p-2 page-dash mb-5">
        <Container fluid className="dataTable-custom-primary">
          {gridComponents.HEADER.length ? (
            <GridHeader context={BI_WS0000Context} />
          ) : (
            <Skeleton className="mb-3" width="100%" height="5rem" />
          )}

          <Row className="m-0 p-0">
            <Col lg={12} className="m-0 p-0">
              {dashboardData.grupos.map((grupo, index) => {
                const groupId = grupo.ID_Dashboard_Grupo || index
                return (
                  <div key={groupId} className="accordion-item accordion-item-dash m-0 mb-3">
                    <h2 className="accordion-header accordion-header-dash m-0 p-0" id={`heading${groupId}`}>
                      <button
                        type="button"
                        className={classnames("accordion-button accordion-button-dash", "fw-medium", {
                          collapsed: !openAccordions.includes(groupId),
                        })}
                        onClick={() => toggleAccordion(groupId)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex w-100 align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <i
                              className={`font-size-24 text-color-azul1 font-w-400 p-0 m-0 fas ${
                                openAccordions.includes(groupId)
                                  ? "fa-angle-up seta-acordion"
                                  : "fa-angle-down seta-acordion"
                              }`}
                            ></i>
                            <span className="font-size-18 text-color-azul1 font-w-600">
                              {grupo.Descricao_Dashboard_Grupo}
                            </span>
                            <span className="notify-circle">{grupo.Qtde_Componentes}</span>
                          </div>
                        </div>
                      </button>
                    </h2>
                    <Collapse isOpen={openAccordions.includes(groupId)}>
                      <div className="accordion-body accordion-body-dash mt-2">
                        <GridAccordion
                          componentes={grupo.componentes}
                          qtde={grupo.Quantidade_Colunas_Grupo}
                          qtlLinha={grupo.Quantidade_Linhas_Grupo}
                          alturaLinha={grupo.Altura_Linhas}
                          GridAutoRows={grupo.GridAutoRows}
                        />
                      </div>
                    </Collapse>
                  </div>
                )
              })}
            </Col>
          </Row>
        </Container>
      </div>
    </BI_WS0000Context.Provider>
  )
}

export default BI_WS0000
